<template>
	<div>
		<div class="contact">
			<div v-html="detail.about_us"></div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				detail:{}
			}
		},
		created(){
			this.getSystem()
		},
		methods:{
			getSystem(){
				this.$api.post('common/getsystem',{type:'sys'},res=>{
					if(res.code == 1){
						this.detail = res.data;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.contact{
		width: 1200px;
		margin: 0 auto;
		padding: 20px;
	}
</style>